import { get, put, post } from "./authenticatedrequestUtil";
import { Chat } from "../../types/Chat";
import { Message } from "../../types/Message";

export const getChats = get<Chat[]>(
  ({ companyId }) => `/${companyId}/chat`
);

export const createChat = post<Chat>(
  ({ companyId, prompt }) => `/${companyId}/chat?prompt=${prompt}`,
);

export const sendMessage = put<string >(
  ({ companyId, chatId, prompt }) => `/${companyId}/chat/${chatId}?prompt=${prompt}`
);

export const getChatMessages = get< Message[] >(
  ({ companyId, chatId }) => `/${companyId}/chat/${chatId}`
);

export const promptByCompany = get<any >(
  ({ companyId, prompt }) => `/${companyId}/prompt?prompt=${prompt}`
);


